export default class Permissions
{
    public static AiCore = class
    {
        public static DynamicFormsGenerator = class
        {
            public static Access = 'Ideo.Core.Common.Application.Permissions.AiCore.DynamicFormsGeneratorPermissions@Access';
        };

        public static TextEditor = class
        {
            public static Access = 'Ideo.Core.Common.Application.Permissions.AiCore.TextEditorPermissions@Access';
        };

        public static ImageMetadataGenerator = class
        {
            public static Access = 'Ideo.Core.Common.Application.Permissions.AiCore.ImageMetadataGeneratorPermissions@Access';
        };

        public static ImageGenerator = class
        {
            public static Access = 'Ideo.Core.Common.Application.Permissions.AiCore.ImageGeneratorPermissions@Access';
        };
    };
}
